import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const { API, PERMISSIONS, CONSTANTS, ENDPOINTS } = buildModuleApi({
    prefix: "USERS", uri: "users",
    exclude: ["LIST", "CREATE", "REMOVE", "DETAIL", "ARCHIVE", "RESTORE", "ARCHIVED",
        "BULK_CREATE", "BULK_ARCHIVE", "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM"],
    withExtra: false,

    overrides: {
        UPDATE: { url: "/users" },
    },

    extraActions: {
        ME: { suffix: "/me" },
    },
});

export const USERS_API = API;
export const USERS_CONSTANTS = CONSTANTS;
export const USERS_ENDPOINTS = ENDPOINTS;
export const USERS_PERMISSIONS = PERMISSIONS;
